import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import { Tabs, Tab } from 'react-bootstrap';

import BasesYearsTab from './BasesYearsTab';

class BasesPeriodsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      key: 1,
      redirect_url: false,
      loaded: 0,
      states: [],
      base_years: {},
      id: this.props.base_id,
      year: null,
    };

    //bind específico
    this.addPeriods = this.addPeriods.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(this.state.loaded === 0 && typeof newProps.base_id !== 'undefined' && Array.isArray(newProps.base_years) && typeof newProps.base_year_period_lists !== 'undefined' || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        id: newProps.base_id,
        base_years: newProps.base_years,
        types_list: newProps.types_list,
        bases_list: newProps.bases_list,
        base_year_period_lists: newProps.base_year_period_lists,
        loaded: 1,
      });
    }
  }
  
  addPeriods(event) {
    event.preventDefault();
    var datasave = {
      base_id: this.state.id,
      year: this.state.year,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    self.props.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/base/ano', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });   
  }
  

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <div>
    <form onSubmit={this.addPeriods}>
      <div className="row">
        <div className="col-md-6 form-group">
          <label>Ano base:</label>
          <input type="text" className="form-control" name="year" value={this.state.year} onChange={this.handleChange.bind(this, 'year')} />
        </div>
      </div>
      <hr/>
      <button type={'submit'} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Adicionar período</button>
    </form>
    <hr/>
    <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
      {Object.keys(this.state.base_years).map(function(k) {
        return (
          <Tab eventKey={self.state.base_years[k].key} title={self.state.base_years[k].year}>
            <BasesYearsTab updateData={self.props.updateData} base_year_period_lists={self.state.base_year_period_lists} updated={self.props.updated} handleAlert={self.props.handleAlert} loadData={self.props.loadData} base_year={self.state.base_years[k]} base_year_id={self.state.base_years[k].id} types_list={self.state.types_list} bases_list={self.state.bases_list} base_year_periods={self.state.base_years[k].base_year_periods} />
          </Tab>
        );
      })}
    </Tabs>
  </div>
</div>
    );
  }
}

export default BasesPeriodsTab;



// WEBPACK FOOTER //
// ./src/Components/Bases/Elements/BasesPeriodsTab.js